import { type FormikErrors } from 'formik'

import {
  type AvailableDate,
  type FormValues,
} from '@/features/listing/components/request-viewing/RequestViewForm/RequestViewingForm'

export const validateDuplicateDates = (values: FormValues) => {
  const errors: FormikErrors<FormValues> = {}
  const availableDateErrors: FormikErrors<AvailableDate>[] = []
  const { availableDates } = values
  const dateTimeMap = new Map<string, number>()

  availableDates.forEach((dateObj, index) => {
    if (!dateObj.date || !dateObj.timeFrom || !dateObj.timeTo) return

    const dateTimeKey = `${dateObj.date}-${dateObj.timeFrom}-${dateObj.timeTo}`
    if (!dateTimeMap.has(dateTimeKey)) {
      dateTimeMap.set(dateTimeKey, index)
      return
    }

    availableDateErrors[index] = {
      date: 'common:forms.inputs.date.duplicate_datetime',
      timeFrom: 'common:forms.inputs.date.duplicate_datetime',
      timeTo: 'common:forms.inputs.date.duplicate_datetime',
    }
  })

  if (availableDateErrors.length > 0) {
    errors.availableDates = availableDateErrors
  }

  return errors
}
